import { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { FlexContainer } from '@/components/Layout/Container';
import { Environment } from '@/models/environment';

type ProductEnvironmentFieldProps = {
    values: Environment[];
    onChange: (environments: Environment[]) => void;
};

export const ProductEnvironmentField: FunctionComponent<
    ProductEnvironmentFieldProps
> = ({ values, onChange }) => {
    const handleChange = (environment: Environment) => () => {
        if (values.includes(environment)) {
            const envIndex = values.indexOf(environment);

            const copyValues = [...values];

            copyValues.splice(envIndex, 1);
            onChange(copyValues);
        } else {
            onChange([...values, environment]);
        }
    };

    return (
        <FlexContainer column>
            <FormGroup
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(Environment.PORTAL)}
                            checked={values?.includes(Environment.PORTAL)}
                            defaultChecked
                        />
                    }
                    label='Portal'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(Environment.INTEGRATION)}
                            checked={values?.includes(Environment.INTEGRATION)}
                            defaultChecked
                        />
                    }
                    label='Webshop'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(Environment.B2B)}
                            checked={values?.includes(Environment.B2B)}
                            defaultChecked
                        />
                    }
                    label='B2B'
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(Environment.HOSPITALITY)}
                            checked={values?.includes(Environment.HOSPITALITY)}
                            defaultChecked
                        />
                    }
                    label='Hospitality'
                />
            </FormGroup>
        </FlexContainer>
    );
};
